module.exports = __webpack_public_path__ + "iconfont.svg";


//////////////////
// WEBPACK FOOTER
// ./src/packages/button/iconfont.svg?t=1564473778850
// module id = 29
// module chunks = 0